/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Attachment, Image, PictureAsPdf } from '@material-ui/icons';
import i18next from 'i18next';
import { hasFileName } from '../../components/draft/attachments/services/constants';
import { humanFileSize } from './stringUtils';
import { fileExtension } from '../enums/fileExtension';
import ZipIcon from '../../components/icons/ZipIcon';
import XmlIcon from '../../components/icons/XmlIcon';

export const getFileIconComponent = (file) => {
  switch (file.fileExtension) {
    case fileExtension.PDF:
      return PictureAsPdf;
    case fileExtension.XML:
      return XmlIcon;
    case fileExtension.ZIP:
      return ZipIcon;
    case fileExtension.JPG:
    case fileExtension.JPEG:
      return Image;
    default:
      return Attachment; // just in case there is an untreated extension
  }
};

export const getFileRejectionMessage = (props) => {
  const { rejectedFile, acceptedMimeTypes = [], acceptedFileExtensions = [], maxFileSize, existingFiles = [] } = props;

  // check if the file type is accepted or not
  if (!acceptedMimeTypes.includes(rejectedFile?.type)) {
    return i18next.t('attachment.validation.invalid-format', {
      acceptedFileExtensions: acceptedFileExtensions.join(', '),
      count: acceptedFileExtensions?.length,
    });
  }

  // check file size
  if (rejectedFile?.size > maxFileSize) {
    return i18next.t('attachment.validation.invalid-file-size', {
      fileSize: humanFileSize(maxFileSize),
    });
  }

  // check if existing files already contain a file with the same name
  if (hasFileName(existingFiles, rejectedFile?.name)) {
    return i18next.t('attachments.warning.same_filename');
  }

  // generic error
  return i18next.t('attachments.warning.other-file-upload-error');
};

export const downloadFile = (href, fileName) => {
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
